// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__seO__","calendarButtons":"ClockData_calendarButtons__3ZM4v"};